/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { IS_PRODUCTION } from '@zcode/env'
import { APP_HOSTNAME } from '@zcode/nr-utils'
import { localStorageSingleton } from '@zcode/nr-utils'
import { useLocation } from 'react-router-dom'
import {
  APN,
  APP_STORE_ID,
  APP_STORE_ID_TEST,
  BANNER_SUFFIXES,
  BANNER_TYPE,
  BUNDLE_ID,
  BUNDLE_ID_TEST,
  CT,
  DETAIL_BANNER_UTM,
  DETAIL_GALLERY_BANNER_UTM,
  DOMAIN,
  DOMAIN_TEST,
  EFR,
  EFR_VALUE,
  HOME_BANNER_UTM,
  IBI,
  ISI,
  LINK,
  MESSAGE_BANNER_UTM,
  MT,
  MT_VALUE,
  PACKAGE_NAME,
  PACKAGE_NAME_TEST,
  PT,
  PT_VALUE,
  SEARCH_BANNER_UTM,
} from '../components/constants'

export const useConstructFirebaseLink = (
  pageType: (typeof BANNER_TYPE)[keyof typeof BANNER_TYPE],
  bannerSuffix: (typeof BANNER_SUFFIXES)[keyof typeof BANNER_SUFFIXES] = BANNER_SUFFIXES.IOS_MWEB_BANNER_SUFFIX
) => {
  const domain = IS_PRODUCTION ? DOMAIN : DOMAIN_TEST
  const firebaseLink = new URL(domain)
  const firebaseLinkParams = firebaseLink.searchParams
  const location = useLocation()
  const deepLink = new URL(
    `https://${APP_HOSTNAME}${location.pathname}${location.search}${location.hash}`
  )

  const traffic: string | undefined = localStorageSingleton.getx('_traffic')
  const campaign: string | undefined = localStorageSingleton.getx('_campaign')

  let trafficParam: string
  if (traffic) {
    trafficParam = `${String(traffic)}-${bannerSuffix}`
    deepLink.searchParams.set('T', trafficParam)
  } else {
    trafficParam = bannerSuffix
    deepLink.searchParams.set('T', trafficParam)
  }
  if (campaign) {
    deepLink.searchParams.set('C', campaign)
  }

  const ctValue = `${campaign || ''},${traffic || ''}-${bannerSuffix}`

  const packageName = IS_PRODUCTION ? PACKAGE_NAME : PACKAGE_NAME_TEST
  const bundleID = IS_PRODUCTION ? BUNDLE_ID : BUNDLE_ID_TEST
  const appStoreID = IS_PRODUCTION ? APP_STORE_ID : APP_STORE_ID_TEST

  firebaseLinkParams.set(LINK, deepLink.toString())
  firebaseLinkParams.set(APN, packageName)
  firebaseLinkParams.set(IBI, bundleID)
  firebaseLinkParams.set(ISI, appStoreID)
  firebaseLinkParams.set(MT, MT_VALUE)
  firebaseLinkParams.set(CT, ctValue)
  firebaseLinkParams.set(PT, PT_VALUE)
  firebaseLinkParams.set(EFR, EFR_VALUE)
  if (pageType === BANNER_TYPE.DETAIL) {
    firebaseLinkParams.set('utm_source', DETAIL_BANNER_UTM)
  } else if (pageType === BANNER_TYPE.HOMEPAGE) {
    firebaseLinkParams.set('utm_source', HOME_BANNER_UTM)
  } else if (pageType === BANNER_TYPE.GALLERY) {
    firebaseLinkParams.set('utm_source', DETAIL_GALLERY_BANNER_UTM)
  } else if (pageType === BANNER_TYPE.SEARCH) {
    firebaseLinkParams.set('utm_source', SEARCH_BANNER_UTM)
  } else if (pageType === BANNER_TYPE.MESSAGING) {
    firebaseLinkParams.set('utm_source', MESSAGE_BANNER_UTM)
  }

  return firebaseLink.toString()
}
